import styled from 'styled-components'
import { v } from '../../../styles/variables'

export const SChartScaleSwitch = styled.div`
	margin: ${v.smSpacing};
	margin-bottom: 0;
	width: fit-content;
	padding-right: 16px;
	border-right: 1px solid ${({ theme }) => theme.bg3};
	display: grid;
`

export const SButtons = styled.div`
	display: flex;
	gap: 4px;
`

export const SChartScaleSwitchButton = styled.button`
	font-size: 13px;
	font-weight: 500;
	background: transparent;
	color: ${({ selectedScale, theme }) => (selectedScale ? theme.strongHighlight : theme.bgText)};
	border: none;
	padding: 4px 10px;
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.15s ease;

	:hover {
		color: ${({ theme }) => theme.text};
		background: ${({ theme }) => theme.bg2};
	}
`

export const SScaleSwitchTitle = styled.span`
	font-size: 11px;
	margin-bottom: 2px;
	color: ${({ theme }) => theme.bgText};
	text-align: center;
	text-transform: uppercase;
	letter-spacing: 0.04em;
`
